import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { KwikUIAnimationPlayerComponent } from "./animation-player.component";
import { KwikUIAnimationPlayerLottieModule } from "./lottie/lottie.module";

@NgModule({
  declarations: [KwikUIAnimationPlayerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KwikUIAnimationPlayerLottieModule
  ],
  exports: [KwikUIAnimationPlayerComponent]
})
export class KwikUIAnimationPlayerModule {}
